import { jsx as i } from "react/jsx-runtime";
import { c as T } from "../../index-C7ezJk5b.js";
import { b as P } from "../../base-nYmjnkiN.js";
import { useState as w, useMemo as l } from "react";
import { cssX as F } from "../../core/utils/css.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const k = ({
  appId: t,
  type: n = "text-light",
  className: g,
  testId: m,
  title: L,
  style: f
}) => {
  const [h, S] = w(!1), { userInfo: { products: r } } = P(), a = l(
    () => {
      var o, e, s, u;
      if (!t)
        return null;
      switch (n) {
        case "regular":
          return (o = r[t]) == null ? void 0 : o.Logo;
        case "gs":
          return (e = r[t]) == null ? void 0 : e.LogoGs;
        case "text":
          return (s = r[t]) == null ? void 0 : s.LogoText;
        case "text-light":
          return (u = r[t]) == null ? void 0 : u.LogoTextLight;
        default:
          return null;
      }
    },
    [t, n, r]
  ), x = l(
    () => {
      var o, e, s, u;
      if (!t)
        return null;
      switch (n) {
        case "regular":
          return (o = r[t]) == null ? void 0 : o.logoSrc;
        case "gs":
          return (e = r[t]) == null ? void 0 : e.logoGsSrc;
        case "text":
          return (s = r[t]) == null ? void 0 : s.logoTextSrc;
        case "text-light":
          return (u = r[t]) == null ? void 0 : u.logoTextLightSrc;
        default:
          return "";
      }
    },
    [t, n, r]
  ), c = l(
    () => ({
      className: T(F("ProductLogo"), g),
      "data-testid": m,
      style: f,
      title: L ?? t ?? "I"
    }),
    [g, m, f]
  );
  return x && !h ? /* @__PURE__ */ i(
    "img",
    {
      ...c,
      src: x,
      alt: t,
      onError: () => {
        S(!0);
      }
    }
  ) : a ? /* @__PURE__ */ i(a, { ...c }) : /* @__PURE__ */ i("div", { ...c });
};
export {
  k as default
};
